import React, { Component } from 'react';
import VariaveisGlobais from './../../utilites/variaveisDoSistema';
import Carregando from './../../fragments/carregando2'
import api from './../../utilites/api';
import { bindActionCreators } from 'redux';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import { setProdSelc, delProdSelc, setCar } from './../../redux/actions';
import { connect } from 'react-redux';
import Montagem from './../../fragments/motagem'
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import Button from '@material-ui/core/Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button as BootstrapButton } from 'react-bootstrap';

// import { Container } from './styles';

class Produto extends Component {

  state = {
    adc: [],
    quant: 1,
    obs: '',
    isLoading: false,
  }

  async componentDidMount() {
    this.setState({ isLoading: true });
    const { setProdSelc, delProdSelc } = this.props;
    // console.log('ProdSEnter: ', this.props.preodSelc.produto)
    delProdSelc();

    const data = new FormData();
    data.append('produto', this.props.location.state.pp.id);

    try {
      const response = await api.post('ws/ListMontagem.php', data);
      // console.log('resposta: ', response.data)
      if (response.status === 200) {
        if (response.status !== '[]') {
          this.setState({
            adc: response.data
          });
        }
        //console.log('sdf ss', this.state.adc[0].itens)
      } else {
        alert('Erro na comunicação com  servidor!', 'Atenção', false);

      }

    } catch (error) {
      // console.log('sdf ss', error)
      alert('Erro na comunicação com servidor!!', 'Atenção', false);
    }
    var u = this.props.location.state.pp;
    u = { ...u, precoUn: u.preco, arrPreco: [], precoAdc: 0, zero: 0, um: 0, dois: 0, tres: 0, quatro: 0, cinco: 0, seis: 0, sete: 0 };

    // Inicializa a propriedade motagem e cria arrays para cada grupo de montagem
    if (Array.isArray(this.state.adc) && this.state.adc.length > 0) {
      u.motagem = this.state.adc.map(grupo => grupo.nome);
      // Para cada grupo, cria um array vazio para armazenar as escolhas
      this.state.adc.forEach(grupo => {
        u[grupo.nome] = [];
      });
      console.log('Produto inicializado com grupos de montagem:', u);
    } else {
      u.motagem = [];
    }

    setProdSelc(u);
    this.setState({ isLoading: false });
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  mascaraValor(valor) {
    valor = valor.toString().replace(/\D/g, "");
    valor = valor.toString().replace(/(\d)(\d{8})$/, "$1.$2");
    valor = valor.toString().replace(/(\d)(\d{5})$/, "$1.$2");
    valor = valor.toString().replace(/(\d)(\d{2})$/, "$1,$2");
    return valor
  }

  form() {
    const vglobais = new VariaveisGlobais();
    const produto = this.props.location.state.pp;
    return (
      <div style={{ 
        background: 'linear-gradient(to bottom, #f8f9fa 0%, #ffffff 20%)', 
        minHeight: '100vh' 
      }}>
        {/* Container para cabeçalho e imagem */}
        <div style={{
          background: '#fff',
          boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
        }}>
          {/* Topo vermelho com botão de voltar */}
          <div style={{
            width: '100%',
            background: 'linear-gradient(135deg, #a52a2a 0%, #8b0000 100%)',
            color: '#fff',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            padding: 0,
            minHeight: 60,
            position: 'relative',
            flexWrap: 'wrap',
            borderBottom: '3px solid rgba(255,255,255,0.2)',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', minWidth: 60, height: '100%' }}>
              <Button
                onClick={() => this.props.history.goBack()}
                style={{ 
                  minWidth: 0, 
                  padding: 10, 
                  color: '#fff', 
                  height: 60,
                  borderRadius: '50%',
                  transition: 'all 0.3s ease',
                  margin: '0 4px',
                }}
                onMouseEnter={(e) => e.target.style.background = 'rgba(255,255,255,0.1)'}
                onMouseLeave={(e) => e.target.style.background = 'transparent'}
              >
                <ArrowBackIcon style={{ color: '#fff', fontSize: 24 }} />
              </Button>
            </div>
            <div
              style={{
                flex: 1,
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: 18,
                letterSpacing: 0.5,
                color: '#fff',
                wordBreak: 'break-word',
                whiteSpace: 'normal',
                padding: '16px 12px 16px 0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: 60,
                textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                lineHeight: 1.3,
              }}
            >
              {produto.nome}
            </div>
          </div>

          {/* Imagem no tamanho original */}
          <div style={{
            width: '100%',
            background: '#fff',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '20px',
            position: 'relative',
          }}>
            <img
              src={vglobais.getHostIMG + '/pod/' + produto.imagem}
              alt={produto.nome}
              style={{
                maxWidth: '100%',
                height: 'auto',
                objectFit: 'contain',
                display: 'block',
              }}
            />
          </div>
        </div>

        {/* Card principal com conteúdo */}
        <div style={{
          background: '#fff',
          borderRadius: '24px 24px 0 0',
          marginTop: -16,
          boxShadow: '0 -8px 32px rgba(0,0,0,0.12)',
          position: 'relative',
          overflow: 'hidden',
        }}>
          {/* Descrição e preço */}
          <div style={{ 
            padding: '24px 24px 20px 24px',
          }}>
            {produto.obs && (
              <div style={{ 
                fontSize: 15, 
                color: '#666', 
                marginBottom: 20, 
                textAlign: 'left',
                lineHeight: 1.6,
                padding: '16px',
                background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                borderRadius: 12,
                border: '1px solid rgba(0,0,0,0.05)',
              }}>
                {produto.obs}
              </div>
            )}
            
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center', 
              marginBottom: 24,
              padding: '20px',
              background: 'linear-gradient(135deg, #fff 0%, #f8f9fa 100%)',
              borderRadius: 16,
              border: '3px solid #a52a2a',
              boxShadow: '0 4px 20px rgba(165, 42, 42, 0.2)',
              position: 'relative',
              overflow: 'hidden',
            }}>
              {/* Efeito de brilho */}
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'linear-gradient(135deg, rgba(255,255,255,0.5) 0%, transparent 50%)',
                pointerEvents: 'none',
              }} />
              
              <div style={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
                <div style={{ fontSize: 14, color: '#666', marginBottom: 4, fontWeight: '500' }}>
                  Preço
                </div>
                <span style={{ 
                  fontWeight: 'bold', 
                  fontSize: 28, 
                  color: '#a52a2a',
                  textShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  fontFamily: 'monospace',
                }}>
                  R$ {this.mascaraValor(Number(this.props.preodSelc.produto.preco).toFixed(2))}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div style={{ background: '#fff', padding: '0 24px' }}>
          {/* Seção de montagem com título */}
          {this.state.adc.length > 0 && (
            <div style={{ marginBottom: 24 }}>
              <h3 style={{
                fontSize: 20,
                fontWeight: 'bold',
                color: '#333',
                marginBottom: 20,
                textAlign: 'center',
                position: 'relative',
                paddingBottom: 12,
              }}>
                Personalize seu pedido
                <div style={{
                  position: 'absolute',
                  bottom: 0,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: 60,
                  height: 3,
                  background: 'linear-gradient(90deg, #a52a2a 0%, #8b0000 100%)',
                  borderRadius: 2,
                }} />
              </h3>
              
              {this.state.adc.map((i, key) => (
                <div key={key} style={{ marginBottom: 20 }}>
                  <Montagem Iten={i} index={key} Key={key+1}/>
                </div>
              ))}
            </div>
          )}
          
          {/* Controles melhorados */}
          <div style={{ 
            marginBottom: 24,
            padding: '24px',
            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
            borderRadius: 16,
            border: '2px solid rgba(165, 42, 42, 0.1)',
            boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
          }}>
            <label style={{ 
              fontSize: 18, 
              fontWeight: "bold",
              color: '#333',
              marginBottom: 20,
              display: 'block',
              textAlign: 'center',
            }}>
              Quantidade
            </label>
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              gap: 24,
              padding: '16px',
              background: '#fff',
              borderRadius: 12,
              boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
            }}>
              <button 
                onClick={this.minuss} 
                style={{ 
                  background: this.state.quant > 1 ? 
                    'linear-gradient(135deg, #a52a2a 0%, #8b0000 100%)' : 
                    '#ccc',
                  border: 'none', 
                  cursor: this.state.quant > 1 ? 'pointer' : 'not-allowed', 
                  padding: 12,
                  borderRadius: '50%',
                  color: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 48,
                  height: 48,
                  transition: 'all 0.3s ease',
                  boxShadow: this.state.quant > 1 ? 
                    '0 4px 12px rgba(165, 42, 42, 0.4)' : 
                    '0 2px 8px rgba(0,0,0,0.1)',
                  transform: 'scale(1)',
                }}
                onMouseDown={(e) => e.target.style.transform = 'scale(0.95)'}
                onMouseUp={(e) => e.target.style.transform = 'scale(1)'}
                onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
              >
                <RemoveIcon />
              </button>
              
              <div style={{
                padding: '12px 24px',
                background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                borderRadius: 12,
                border: '2px solid #a52a2a',
                minWidth: 80,
                textAlign: 'center',
              }}>
                <span style={{ 
                  fontSize: 28, 
                  fontWeight: "bold",
                  color: '#a52a2a',
                  fontFamily: 'monospace',
                }}>
                  {this.state.quant}
                </span>
              </div>
              
              <button 
                onClick={this.pluss} 
                style={{ 
                  background: 'linear-gradient(135deg, #a52a2a 0%, #8b0000 100%)',
                  border: 'none', 
                  cursor: 'pointer', 
                  padding: 12,
                  borderRadius: '50%',
                  color: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 48,
                  height: 48,
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 12px rgba(165, 42, 42, 0.4)',
                  transform: 'scale(1)',
                }}
                onMouseDown={(e) => e.target.style.transform = 'scale(0.95)'}
                onMouseUp={(e) => e.target.style.transform = 'scale(1)'}
                onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
              >
                <AddIcon />
              </button>
            </div>
          </div>
          
          <div style={{ 
            marginBottom: 32,
            padding: '24px',
            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
            borderRadius: 16,
            border: '2px solid rgba(165, 42, 42, 0.1)',
            boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
          }}>
            <InputLabel 
              htmlFor="input-with-icon-adornment"
              style={{ 
                fontSize: 18,
                fontWeight: 'bold',
                color: '#333',
                marginBottom: 16,
                textAlign: 'center',
              }}
            >
              Observações
            </InputLabel>
            <Input
              value={this.state.obs}
              useNativeDriver={true}
              name="obs"
              multiline={true}
              rows={3}
              style={{ 
                width: '100%',
                background: '#fff',
                padding: '16px',
                borderRadius: 12,
                border: '2px solid rgba(165, 42, 42, 0.2)',
                fontSize: 15,
                lineHeight: 1.4,
                boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
              }}
              onChange={this.handleChange}
              placeholder="Digite aqui qualquer observação especial para seu pedido..."
            />
          </div>
          {/* <a style={{ marginLeft: 15, marginTop: 25, backgroundColor: 'green', width: '100%', }} onPress={() => {
            this.setState({ isLoading: true });
            const { setCar, setProdSelc } = this.props;

            var listTemp = this.props.preodSelc.produto;
            var pTemp = parseFloat(this.props.preodSelc.produto.preco) * parseFloat(this.state.quant)
            listTemp = { ...listTemp, preco: pTemp, quant: this.state.quant, observacao: this.state.obs }
            //setProdSelc(listTemp);

            var tt = listTemp;
            setCar(tt);

            console.log('ProdSelc: ', this.props.carrinho);
            this.props.navigation.goBack()
          }}>
            <label>Adcionar ao carrinho</label>
          </a> */}
          <Button 
            variant="contained" 
            color="primary" 
            style={{
              width: '100%',
              height: 64,
              background: 'linear-gradient(135deg, #a52a2a 0%, #8b0000 100%)',
              color: '#fff',
              fontSize: 20,
              fontWeight: 'bold',
              borderRadius: 16,
              textTransform: 'none',
              boxShadow: '0 6px 24px rgba(165, 42, 42, 0.4)',
              border: 'none',
              transition: 'all 0.3s ease',
              letterSpacing: 0.5,
              position: 'relative',
              overflow: 'hidden',
            }}
            onClick={() => {
              this.setState({ isLoading: true });
              const { setCar } = this.props;

              // Sempre pega o produto atualizado do Redux
              let listTemp = JSON.parse(JSON.stringify(this.props.preodSelc.produto));

              console.log('Produto antes de adicionar ao carrinho:', listTemp);

              // Garante que a propriedade 'motagem' está presente e correta
              if (!Array.isArray(listTemp.motagem) || !listTemp.motagem.length) {
                if (Array.isArray(this.state.adc) && this.state.adc.length > 0) {
                  listTemp.motagem = this.state.adc.map(grupo => grupo.nome);
                } else {
                  listTemp.motagem = [];
                }
              }

              // Para cada grupo de montagem, NÃO sobrescreve se já houver escolhas
              if (Array.isArray(listTemp.motagem)) {
                listTemp.motagem.forEach(grupo => {
                  // Se não existe array ou está vazio, cria vazio
                  if (!Array.isArray(listTemp[grupo])) {
                    listTemp[grupo] = [];
                  }
                });
              }

              // Atualiza preço e quantidade
              var pTemp = parseFloat(listTemp.preco) * parseFloat(this.state.quant);
              listTemp = { ...listTemp, preco: pTemp, quant: this.state.quant, observacao: this.state.obs };

              // Garante que as escolhas de montagem estão presentes
              // Remove grupos de montagem vazios da lista final
              if (Array.isArray(listTemp.motagem)) {
                listTemp.motagem = listTemp.motagem.filter(grupo => Array.isArray(listTemp[grupo]) && listTemp[grupo].length > 0);
              }

              console.log('Produto final para adicionar ao carrinho:', listTemp);
              console.log('Grupos de montagem:', listTemp.motagem);
              
              setCar(listTemp);
              this.props.history.goBack();
            }} 
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 8px 32px rgba(165, 42, 42, 0.5)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 6px 24px rgba(165, 42, 42, 0.4)';
            }}
          >
            {/* Efeito de brilho no botão */}
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'linear-gradient(135deg, rgba(255,255,255,0.2) 0%, transparent 50%)',
              pointerEvents: 'none',
            }} />
            <span style={{ position: 'relative', zIndex: 1 }}>
              🛒 Adicionar ao carrinho
            </span>
          </Button>
          <div style={{ height: 48 }} />
        </div>
      </div>
    );
  }

  pluss = () => {

    this.setState({
      quant: this.state.quant + 1
    });

  }

  minuss = () => {
    if (this.state.quant > 1) {
      this.setState({
        quant: this.state.quant - 1
      });
    }

  }

  render() {
    return (
      this.state.isLoading ? <Carregando /> : this.form()
    );
  }
}

const mapStateToProps = state => ({
  preodSelc: state.SelecReducer,
  carrinho: state.CarrinhoReducer
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ setProdSelc, delProdSelc, setCar }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Produto);
